import { ConfigDomain } from 'domain/configs/config.types';
import { Config } from 'domain/configs/models/config';
import { YOOGA_ADDITIONAL_TAX_CONFIG } from '../../AdditionalTax/AdditionalTaxContext';

export default function filterConfigs(
  configs: Config[],
  search: string,
  isToken?: boolean,
  isBoolean?: boolean,
  isActive?: boolean,
  isNotActive?: boolean,
  domain?: ConfigDomain,
): Config[] {
  let filteredConfigs: Config[] = configs.filter(
    (config) => config.name !== YOOGA_ADDITIONAL_TAX_CONFIG,
  );

  if (!!search || isToken || isBoolean || isActive || isNotActive || domain)
    filteredConfigs = filteredConfigs.filter((config) => {
      if (!!domain && config.domain !== domain) return false;

      if (
        !!search &&
        !config.name.toLowerCase().includes(search.toLowerCase()) &&
        !config.description.toLowerCase().includes(search.toLowerCase())
      )
        return false;

      if (isToken && config.type !== 'TOKEN') return false;

      if (isBoolean && config.type !== 'BOOLEAN') return false;

      if (
        isActive &&
        ((config.type === 'BOOLEAN' && !config.booleanValue) ||
          (config.type === 'TOKEN' && !config.trueValue))
      )
        return false;

      if (
        isNotActive &&
        ((config.type === 'BOOLEAN' && config.booleanValue) ||
          (config.type === 'TOKEN' && config.trueValue))
      )
        return false;

      return true;
    });

  return filteredConfigs;
}
